import { useTheme } from "@mui/material";
import { useGetMetricsQuery } from "~/operations";
import { Metrics, parseMetrics } from "~/lib/arrow";

type UseMetricsParams = {
  entityMrn: string;
  metricMrns: Array<Metrics>;
  startTime?: string;
  endTime?: string;
  key?: string;
  skip?: boolean;
};

export function useMetrics({
  entityMrn,
  metricMrns,
  startTime,
  endTime,
  key,
  skip,
}: UseMetricsParams) {
  const theme = useTheme();

  const { data, loading, error, refetch, networkStatus } = useGetMetricsQuery({
    variables: {
      entityMrn,
      metricMrns,
      startTime,
      endTime,
      key,
    },
    skip: !entityMrn || skip,
  });

  return {
    isLoading: loading,
    error,
    refetch,
    networkStatus,
    ...parseMetrics(data?.metrics?.entries || [], theme),
  };
}
